var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", "max-width": "600px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("h3", { staticClass: "headline mb-0" }, [
                  _vm._v(
                    "\n          Activar/Desactivar Integración de la Flota\n        "
                  )
                ])
              ]),
              _c("v-divider"),
              _c("v-card-title", [
                _vm._v("Código de la flota: " + _vm._s(_vm.item.cod_flota))
              ]),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticStyle: { height: "500px" } },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", xs12: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md12: "" } },
                                    [
                                      _c("v-switch", {
                                        attrs: { label: _vm.labelSwitch },
                                        on: { change: _vm.onChangeSwitch },
                                        model: {
                                          value: _vm.switch1,
                                          callback: function($$v) {
                                            _vm.switch1 = $$v
                                          },
                                          expression: "switch1"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _vm.integrationConfig.avl_chile
                                        ? _c("v-checkbox", {
                                            attrs: { label: "avl_chile" },
                                            model: {
                                              value: _vm.item.avl_chile,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "avl_chile",
                                                  $$v
                                                )
                                              },
                                              expression: "item.avl_chile"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig
                                        .wisetrack_insertarposicion
                                        ? _c("v-checkbox", {
                                            attrs: {
                                              label:
                                                "wisetrack_insertarposicion"
                                            },
                                            model: {
                                              value:
                                                _vm.item
                                                  .wisetrack_insertarposicion,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "wisetrack_insertarposicion",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.wisetrack_insertarposicion"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.cmp_btrack
                                        ? _c("v-checkbox", {
                                            attrs: { label: "cmp_btrack" },
                                            model: {
                                              value: _vm.item.cmp_btrack,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "cmp_btrack",
                                                  $$v
                                                )
                                              },
                                              expression: "item.cmp_btrack"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.log_solutions
                                        ? _c("v-checkbox", {
                                            attrs: { label: "log_solutions" },
                                            model: {
                                              value: _vm.item.log_solutions,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "log_solutions",
                                                  $$v
                                                )
                                              },
                                              expression: "item.log_solutions"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.int_samtech_cim
                                        ? _c("v-checkbox", {
                                            attrs: { label: "int_samtech_cim" },
                                            model: {
                                              value: _vm.item.int_samtech_cim,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "int_samtech_cim",
                                                  $$v
                                                )
                                              },
                                              expression: "item.int_samtech_cim"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.beetrack
                                        ? _c("v-checkbox", {
                                            attrs: { label: "beetrack" },
                                            model: {
                                              value: _vm.item.beetrack,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "beetrack",
                                                  $$v
                                                )
                                              },
                                              expression: "item.beetrack"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "", md6: "" } },
                                    [
                                      _vm.integrationConfig.owl
                                        ? _c("v-checkbox", {
                                            attrs: { label: "owl" },
                                            model: {
                                              value: _vm.item.owl,
                                              callback: function($$v) {
                                                _vm.$set(_vm.item, "owl", $$v)
                                              },
                                              expression: "item.owl"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.heligrafics
                                        ? _c("v-checkbox", {
                                            attrs: { label: "heligrafics" },
                                            model: {
                                              value: _vm.item.heligrafics,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "heligrafics",
                                                  $$v
                                                )
                                              },
                                              expression: "item.heligrafics"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.qanalytics
                                        ? _c("v-checkbox", {
                                            attrs: { label: "qanalytics" },
                                            model: {
                                              value: _vm.item.qanalytics,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "qanalytics",
                                                  $$v
                                                )
                                              },
                                              expression: "item.qanalytics"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.samtech_dch
                                        ? _c("v-checkbox", {
                                            attrs: { label: "samtech_dch" },
                                            model: {
                                              value: _vm.item.samtech_dch,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "samtech_dch",
                                                  $$v
                                                )
                                              },
                                              expression: "item.samtech_dch"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.int_codelco
                                        ? _c("v-checkbox", {
                                            attrs: { label: "int_codelco" },
                                            model: {
                                              value: _vm.item.int_codelco,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "int_codelco",
                                                  $$v
                                                )
                                              },
                                              expression: "item.int_codelco"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.integrationConfig.int_camion_go
                                        ? _c("v-checkbox", {
                                            attrs: { label: "int_camion_go" },
                                            model: {
                                              value: _vm.item.int_camion_go,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.item,
                                                  "int_camion_go",
                                                  $$v
                                                )
                                              },
                                              expression: "item.int_camion_go"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red darken-1", flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close", false)
                        }
                      }
                    },
                    [_vm._v("Cerrar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success darken-1" },
                      on: {
                        click: function($event) {
                          _vm.$emit("close", false)
                          _vm.$emit("change", _vm.item)
                        }
                      }
                    },
                    [_vm._v("Guardar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }